<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <date-format-select
        @changeDateFormatData="changeDateFormatData($event.dateFormatId)"
        :isMonthly="true"
      />
      <search-channel-select v-model="tableParams.channelId" />
      <search-channel-slot-select
        v-model="slotIdList"
        :channel-id="tableParams.channelId"
        multiple
      />
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        :hide="hides"
        style="padding-bottom: 10px"
      >
        <el-button
          @click="
            downExcel('/webReportChannelSlot/csv', '渠道请求报表', tableParams)
          "
          type="warning"
          size="small"
          >下载</el-button
        >
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        @sort-change="sortChange"
        :header-cell-style="{ background: '#fafafa' }"
        :summary-method="tableSummary"
        show-summary
        highlight-current-row
        size="small"
        ref="report"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-if="
            tableParams.isDay === 1 ||
            tableParams.isHour === 1 ||
            tableParams.isMonth === 1
          "
          prop="timeHour"
          :label="
            tableParams.isDay === 1 || tableParams.isMonth === 1
              ? '日期'
              : '时间'
          "
          fixed
          sortable
          align="center"
        />
        <el-table-column
          v-for="(v, i) in checkColumns"
          align="center"
          :prop="v.field"
          :sortable="
            v.field === 'uniShowSmt' ||
            v.field === 'uniClkSmt' ||
            v.field === 'reqSmt' ||
            v.field === 'time' ||
            v.field === 'repSmt' ||
            v.field === 'showRat' ||
            v.field === 'fillingRate' ||
            v.field === 'clickRate' ||
            v.field === 'dpRate' ||
            v.field === 'dpSmt' ||
            v.field === 'resSmt' ||
            v.field === 'uniWinSmt' ||
            v.field === 'bidPrice' ||
            v.field === 'basePrice' ||
            v.field === 'bidDspPrice' ||
            v.field === 'channelEcpm' ||
            v.field === 'ecpmAverage' ||
            v.field === 'realBidPrice' ||
            v.field === 'auctionPrice' ||
            v.field === 'profit' ||
            v.field === 'winPrice' ||
            v.field === 'cpcPrice' ||
            v.field === 'reportTime'
          "
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
        >
          <template v-slot="scope">
            <el-tag
              v-if="
                v.field === 'deeplinkNumberProportion' ||
                v.field === 'timeoutNumberProportion'
              "
              type="info"
              >{{ scope.row[v.field] }}</el-tag
            >
            <el-tag
              v-else-if="
                v.field === 'showRat' ||
                v.field === 'clickRate' ||
                v.field === 'dpRate' ||
                v.field === 'fillingRate' ||
                v.field === 'bidRate'
              "
              type="info"
              >{{ scope.row[v.field] }}%</el-tag
            >
            <span v-else style="display: inline-block">{{
              scope.row[v.field]
            }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="图表">
          <template v-slot="scope" align="center">
            <el-button
              size="mini"
              @click="openMyEchart(scope.row)"
              :disabled="scope.row['appId']"
              >查看</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60, 100, 200]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
    <el-dialog
      v-model="dialogStatus"
      :close-on-click-modal="false"
      @close="close"
      width="80%"
      append-to-body
    >
      <my-echart :listData="listData" :title="'报表图'" />
    </el-dialog>
  </div>
</template>

<script>
import DateFormatSelect from '@/components/DateFormatSelect'
import SearchChannelSelect from '@/components/SearchChannelSelect'
import SearchDspSlotSelect from '@/components/SearchDspSlotSelect'
import SearchDspSelect from '@/components/SearchDspSelect'
import SearchChannelSlotSelect from '@/components/SearchChannelSlotSelect'
import SearchSlotTypeSelect from '@/components/SearchSlotTypeSelect'
import BaseDatePicker from '@/components/BaseDatePicker'
import TableColumn from '@/components/TableColumn'
import SearchBudgetType from '@/components/SearchBudgetType'
import {
  getChannelDetailReportList,
  getChanneltList
} from '@/api/report/channel'
import initTableMixin from '@/mixins/initTable'
import downExcelMixin from '@/mixins/downExcel'
import myEchart from '@/components/myEchart'

import { uuid } from '@/util/util'

export default {
  name: 'Channel',
  components: {
    DateFormatSelect,
    SearchChannelSelect,
    SearchDspSelect,
    SearchDspSlotSelect,
    SearchChannelSlotSelect,
    SearchSlotTypeSelect,
    BaseDatePicker,
    TableColumn,
    SearchBudgetType,
    myEchart
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    return {
      columns: [
        { field: 'channelId', title: '渠道编号' },
        { field: 'channelName', title: '渠道名称' },
        { field: 'slotId', title: '广告位编号' },
        { field: 'slotName', title: '广告位名称' },
        { field: 'reqSmt', title: '渠道有效请求' },
        { field: 'resSmt', title: '渠道有效填充' },
        { field: 'fillingRate', title: '填充率' },
        { field: 'filterCount', title: '过滤统计值' },
        { field: 'filterDesc', title: '过滤值' }
      ],
      hides: ['uniWinSmt', 'bidRate', 'dpSmt', 'cpcPrice'],
      listData: [],
      dialogStatus: false,
      slotIdList: [],
      dspSlotIdList: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/webReportChannelSlot/list'
      this.tableParams.pageNum = this.pagination.pageNum
      this.tableParams.pageSize = this.pagination.pageSize
      return true
    },
    afterInit (res) {
      this.tableData = this.generateTableId(res.data.records, 0)
    },
    currentChange (event) {
      this.tableParams.pageNum = event
      this.pagination.pageNum = event
    },
    sizeChange (e) {
      this.pagination.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange (e) {
      this.pagination.pageNum = e
      this.tableParams.pageNum = e
      this.init()
    },
    changeDate (date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    toQuery () {
      if (this.slotIdList) {
        this.tableParams.slotIdList = this.slotIdList.join(',')
      }
      this.init()
    },
    changeDateFormatData (dateFormatId) {
      this.tableParams.showType = dateFormatId
      this.tableParams.isDay = null
      this.tableParams.isHour = null
      this.tableParams.isMonth = null
      if (dateFormatId === 0) {
        this.tableParams.isDay = 2
        this.tableParams.isHour = 2
        this.tableParams.isMonth = 2
      } else if (dateFormatId === 1) {
        this.tableParams.isDay = 1
      } else if (dateFormatId === 2) {
        this.tableParams.isHour = 1
      } else if (dateFormatId === 3) {
        this.tableParams.isMonth = 1
      }
      this.tableParams.asc = ''
      this.tableParams.desc = ''
    },
    load (tree, treeNode, resolve) {
      this.$nextTick(() => {
        const search = {
          slotId: tree.slotId,
          dspId: tree.dspId,
          budget: this.tableParams.budget,
          isDayHourMonth: this.dateFormatId,
          asc: this.tableParams.asc,
          desc: this.tableParams.desc
        }
        if (tree.reportTime === undefined || this.dateFormatId === 3) {
          search.endTime = this.tableParams.endTime
          search.startTime = this.tableParams.startTime
          if (this.dateFormatId === 2 || this.dateFormatId === 3) {
            search.startTime = search.startTime + '00'
            search.endTime = search.endTime + '23'
          }
        } else {
          search.endTime = tree.reportTime
          search.startTime = tree.reportTime
        }
        getChannelDetailReportList(search).then((res) => {
          if (res.code === 200) {
            resolve(this.generateTableId(res.data, tree.id))
          }
        })
      })
    },
    generateTableId (data, base) {
      if (!data) return []
      for (let i = 0; i < data.length; i++) {
        data[i].id = uuid()

        if (base === 0) {
          data[i].hasChildren = true
        } else {
          data[i].slotId = data[i].dspSlotCode
          data[i].slotName = data[i].dspSlotName
        }
      }
      return data
    },
    sortChange (column) {
      this.tableParams.asc = ''
      this.tableParams.desc = ''
      if (column.order === 'ascending') {
        this.tableParams.asc = column.prop
      } else {
        this.tableParams.desc = column.prop
      }
      this.init()
    },
    // down() {
    //   const parms = Object.assign({}, this.tableParams);
    //   parms.isDayHourMonth = this.dateFormatId;
    //   if (this.dateFormatId === 2) {
    //     parms.startTime = parms.startTime + "00";
    //     parms.endTime = parms.endTime + "23";
    //   }
    //   this.downExcel("/report/channel/detail/list/csv", "渠道请求报表", parms);
    // },
    tableSummary (row) {
      const arr = [
        'uniShowSmt',
        'uniClkSmt',
        'reqSmt',
        'resSmt',
        'dpSmt',
        'uniWinSmt',
        'bidPrice',
        'basePrice',
        'bidDspPrice',
        'realBidPrice'
      ]
      const fixedArr = ['auctionPrice', 'winPrice', 'profit']
      const fixed2Arr = [
        'channelEcpm',
        'ecpmAverage',
        'fillingRate',
        'showRat',
        'clickRate',
        'dpRate',
        'bidRate'
      ]
      const { data } = row
      const checklists = this.checkColumns.map((item) => {
        return item.field
      })
      if (this.tableParams.isDay === 1 || this.tableParams.isHour === 1) {
        checklists.unshift('0')
      }
      const out = []
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = '合计'
        } else {
          if (fixedArr.indexOf(checklists[i]) > -1) {
            out[i] = data
              .reduce((total, item) => {
                return total + Number(item[checklists[i]])
              }, 0)
              .toFixed(4)
          } else if (fixed2Arr.indexOf(checklists[i]) > -1) {
            switch (checklists[i]) {
              case 'channelEcpm':
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.auctionPrice)
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt)
                    }, 0)) *
                  1000
                ).toFixed(4)
                break
              case 'ecpmAverage':
                out[i] = (
                  (data
                    .reduce((total, item) => {
                      return total + Number(item.winPrice)
                    }, 0)
                    .toFixed(4) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt)
                    }, 0)) *
                  1000
                ).toFixed(2)
                break
              case 'fillingRate':
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.resSmt)
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.reqSmt)
                    }, 0)) *
                  100
                ).toFixed(2)
                break
              case 'showRat':
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.uniShowSmt)
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.resSmt)
                    }, 0)) *
                  100
                ).toFixed(2)
                break
              case 'clickRate':
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.uniClkSmt)
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt)
                    }, 0)) *
                  100
                ).toFixed(2)
                break
              case 'dpRate':
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.dpSmt)
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniClkSmt)
                    }, 0)) *
                  100
                ).toFixed(2)
                break
              case 'bidRate':
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.uniWinSmt)
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.resSmt)
                    }, 0)) *
                  100
                ).toFixed(2)
                break
            }
          } else {
            out[i] =
              arr.indexOf(checklists[i]) > -1
                ? data.reduce((total, item) => {
                  return total + Number(item[checklists[i]])
                }, 0)
                : '-'
          }
        }
      }
      return out
    },
    openMyEchart (data) {
      this.dialogStatus = true
      const search = {
        slotId: data.slotId,
        dspId: data.dspId,
        isDay: 2,
        isHour: 1,
        pageNum: 1,
        pageSize: 1000,
        desc: 'reportTime'
      }
      search.endTime = this.tableParams.endTime
      search.startTime = this.tableParams.startTime
      getChanneltList(search).then((res) => {
        if (res.code === 200) {
          this.listData = res.data.records
        }
      })
    },
    close () {
      this.listData = []
      this.dialogStatus = false
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}

::v-deep.el-table__placeholder {
  display: none;
}

::v-deep.el-table__expand-icon {
  width: auto !important;
}

// /deep/.el-table__footer-wrapper tbody td{
//   border-bottom: none;
//   .cell{
//   overflow: hidden;
//   text-overflow: ellipsis;
//   word-break:normal
//   }
// }
// /deep/.el-table__fixed-footer-wrapper tbody td{
//   border-bottom: none;
//   .cell{
//       word-break:normal;
//   }
// }
// /deep/.el-table__fixed-header-wrapper .cell{
//   width: 70px;
// }
// /deep/.el-table__body-wrapper {
//   order: 0;
// }
</style>
